export default function TvIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.33333 13.9997H10.6667M9.33333 13.9997C8.78107 13.9997 8.33333 13.5519 8.33333 12.9997V11.333H8M9.33333 13.9997H6.66667M8 11.333H7.66667V12.9997C7.66667 13.5519 7.21893 13.9997 6.66667 13.9997M8 11.333V13.9997M6.66667 13.9997H5.33333"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6667 2H5.33333C3.44771 2 2.50491 2 1.91912 2.58579C1.33333 3.17157 1.33333 4.11438 1.33333 6V7.33333C1.33333 9.21893 1.33333 10.1617 1.91912 10.7475C2.50491 11.3333 3.44771 11.3333 5.33333 11.3333H10.6667C12.5523 11.3333 13.4951 11.3333 14.0809 10.7475C14.6667 10.1617 14.6667 9.21893 14.6667 7.33333V6C14.6667 4.11438 14.6667 3.17157 14.0809 2.58579C13.4951 2 12.5523 2 10.6667 2Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.71733 6.15699L7.45933 4.74574C7.377 4.69428 7.28187 4.66699 7.18473 4.66699C6.8986 4.66699 6.66667 4.89895 6.66667 5.18507V8.14893C6.66667 8.43506 6.8986 8.66699 7.18473 8.66699C7.28187 8.66699 7.377 8.63973 7.45933 8.58826L9.71733 7.17699C9.8932 7.06706 10 6.87433 10 6.66699C10 6.45963 9.8932 6.26689 9.71733 6.15699Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
